import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

export default ({ items, opened, selectedItem, onSelect, onClick }) => {
    const dropdownClasses = classNames('dropdown', {
        'is-active': opened,
    });

    return (
        <div className={dropdownClasses}>
            <div className="dropdown-trigger" onClick={onClick}>
                <button className="button has-text-weight-bold">
                    <FormattedMessage
                        id={
                            selectedItem
                                ? `exhibitApplication.services.${
                                      selectedItem.name
                                  }.title`
                                : 'exhibitApplication.applicationTypeButton'
                        }
                        tagName="span"
                    />
                    <span className="icon is-small">
                        <i className="fas fa-angle-down" />
                    </span>
                </button>
            </div>
            <div className="dropdown-menu">
                <div className="dropdown-content">
                    {items.map((item) => (
                        <a
                            key={item.name}
                            onClick={onSelect}
                            data-name={item.name}
                            className={classNames('dropdown-item', {
                                'is-active':
                                    selectedItem &&
                                    item.name === selectedItem.name,
                            })}
                        >
                            <FormattedMessage
                                id={`exhibitApplication.services.${
                                    item.name
                                }.title`}
                            />
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/ContactForm/components/ServiceDropdown.js